import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Heart, ArrowLeft, AlertCircle } from 'lucide-react'
import MovieCard from '../components/MovieCard'
import { supabase, isConfigured } from '../lib/supabase'

export default function Favorites({ session }) {
  const navigate = useNavigate()
  const [movies, setMovies] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!session) { navigate('/auth'); return }
    if (!isConfigured || !supabase) {
      setLoading(false)
      return
    }
    supabase.from('favorites').select('*, movies(*)').eq('user_id', session.user.id).then(({ data, error }) => {
      if (!error && data) setMovies(data.map(f => f.movies).filter(Boolean))
      setLoading(false)
    })
  }, [session])

  return (
    <div className="pt-20 px-4 max-w-7xl mx-auto">
      <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-400 hover:text-white mb-6 transition-colors">
        <ArrowLeft className="w-4 h-4" /> Kembali
      </button>
      <h1 className="text-2xl font-bold mb-6 flex items-center gap-2"><Heart className="w-6 h-6 text-red-500" /> Favorit</h1>
      {!isConfigured && (
        <div className="mb-6 p-4 bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 text-sm rounded-lg flex items-start gap-3">
          <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-semibold">Supabase belum dikonfigurasi</p>
            <p className="text-xs opacity-80">Favorit butuh database Supabase. Setup project dan jalankan <code>supabase_schema.sql</code>.</p>
          </div>
        </div>
      )}
      {loading ? <div className="flex justify-center py-12"><div className="w-8 h-8 border-2 border-red-500 border-t-transparent rounded-full animate-spin" /></div>
        : movies.length > 0 ? <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">{movies.map(m => <MovieCard key={m.id} movie={m} />)}</div>
        : <p className="text-gray-400 text-center py-12">Belum ada film favorit</p>}
    </div>
  )
}